<ion-row class="ion-align-items-center">
  <ion-col size="12" size-md>
    <div class="phi-flex-wrap-center phi-gap-12">
      <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <mat-select placeholder="Select Year" (selectionChange)="applyDataFilters($event.value, 'selectedYear')" [(ngModel)]="selectedFilters.selectedYear" dropdownPosition="bottom">
          <mat-option *ngFor="let year of listOfYears" [value]="year.key">{{year.value}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
        <input readonly matInput [matDatepicker]="fromToDate" placeholder="DD/MM/YYYY" [(ngModel)]="selectedFilters.selectedDate" (dateChange)="applyDataFilters($event.value, 'selectedDate')" />
        <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
        <mat-datepicker #fromToDate></mat-datepicker>
      </mat-form-field>

      <ng-multiselect-dropdown class="w-100 mw-sm-225 mat-height40 mat-input-style" [data]="departmentsList" [(ngModel)]="selectedFilters.selectedDepartment" [settings]="multiDropdownSettings" placeholder="Select Department" (onSelect)="applyDataFilters($event, 'selectedDepartment')" (onDeSelect)="applyDataFilters($event, 'selectedDepartment')" (onSelectAll)="applyDataFilters($event, 'selectedDepartment')" (onDeSelectAll)="applyDataFilters($event, 'selectedDepartment')"></ng-multiselect-dropdown>

      <ng-multiselect-dropdown class="w-100 mw-sm-150 mat-height40 mat-input-style" [data]="gradesList" [(ngModel)]="selectedFilters.selectedGrade" [settings]="multiDropdownSettings" placeholder="Select Grade" (onSelect)="applyDataFilters($event, 'selectedGrade')" (onDeSelect)="applyDataFilters($event, 'selectedGrade')" (onSelectAll)="applyDataFilters($event, 'selectedGrade')" (onDeSelectAll)="applyDataFilters($event, 'selectedGrade')"></ng-multiselect-dropdown>

      <!-- <ng-select class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Department" (change)="applyDataFilters($event, 'selectedDepartment')" [(ngModel)]="selectedFilters.selectedDepartment" dropdownPosition="bottom" [searchable]="true">
        <ng-option [value]="departments" *ngFor="let departments of departmentsList">{{departments}}</ng-option>
      </ng-select>

      <ng-select class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="false" placeholder="Select Grade" (change)="applyDataFilters($event, 'selectedGrade')" [(ngModel)]="selectedFilters.selectedGrade" dropdownPosition="bottom" [searchable]="true">
        <ng-option [value]="grades" *ngFor="let grades of gradesList">{{grades}}</ng-option>
      </ng-select> -->

      <ng-select class="w-100 mw-sm-150 mat-height40 mat-input-style" [clearable]="true" placeholder="Select Employee" (change)="applyDataFilters($event, 'selectedEmpId')" [(ngModel)]="selectedFilters.selectedEmpId" dropdownPosition="bottom" [searchable]="true">
        <ng-option [value]="item?.id" *ngFor="let item of employeesList">{{ item?.firstName }} {{ item?.lastName }}</ng-option>
      </ng-select>

      <button class="center-content clear-filter-btn">
        <u class="cp link fs_14ForMobile" (click)="applyDataFilters('', '', false)">Clear Filter</u>
      </button>
    </div>
  </ion-col>
  <ion-col size="12" size="auto">
    <div class="phi-flex-wrap-center phi-gap-12">
      <button type="button" class="dwm_btn fs-14 fs_12ForMobile" (click)="auditpopup(null)">Audit Trail</button>
    </div>
  </ion-col>
</ion-row>

<div class="table-card-box mb-15">
  <ion-row>
    <ion-col size>
      <div class="phi-flex-wrap-center phi-gap-12 mb-5">
        <button (click)="onClickDeleteRecord()" [disabled]="disableDelete" *ngIf="selectedTaskList?.length > 0 && userIsAdminTypes?.userIsAdmin" class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold">
          <span class="material-icons fs-20">delete</span>
        </button>
        <mat-form-field class="w-100 mw-sm-175 mat-height40 mat-input-style" *ngIf="selectedFilters?.selectedEmpId">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" (input)="onSearch($event)" [(ngModel)]="selectedFilters.searchString" [disabled]="!selectedFilters.selectedEmpId" />
        </mat-form-field>
        <ng-select class="w-100 mw-sm-150" [clearable]="false" placeholder="Dwm Type" *ngIf="selectedFilters?.selectedEmpId && userIsAdminTypes?.userIsAdmin" [(ngModel)]="selectedFilters.selectedDwmType" [items]="getAllDwmTypes" appendTo="body" dropdownPosition="bottom" (change)="applyDataFilters($event, 'selectedDwmType')">
          <ng-option *ngFor="let f of getAllDwmTypes" [value]="f">{{ f }}</ng-option>
        </ng-select>
      </div>
    </ion-col>
    <ion-col size="auto" *ngIf="selectedFilters?.selectedEmpId">
      <div class="phi-flex-wrap-center phi-gap-12">
        <span class="hrs-and-achievement total-hours" *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd">
          Total Hours Worked =
          <strong class="ml-5">{{ achievementTotalHrs?.totalHoursWorked || '00:00' }}</strong>
        </span>
        <span class="hrs-and-achievement achievment" *ngIf="achievementTotalHrs?.complianceScore">
          Achievement =
          <strong class="ml-5 ">{{ achievementTotalHrs?.complianceScore ?? 0 }}%</strong>
        </span>
        <!-- <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedFilters?.selectedEmpId && userIsAdminTypes?.userIsAdmin" (click)="saveAllRecords(paginatedData)" [disabled]="!selectedFilters.selectedEmpId">Save All</button> -->

        <button *ngIf="userIsAdminTypes?.userIsAdmin" type="button" class="dwm_btn fs-14 fs_12ForMobile" (click)="addNewTask(paginatedData)">+ New DWM</button>
        <span *ngIf="dwmSkippDay.isSkipped" class="applied-skip-day" [innerHTML]="dwmSkippDay.isSkippedText"></span>
        <div class="download-btns phi-flex-wrap-center phi-gap-12" *ngIf="selectedFilters.selectedEmpId">
          <img src="assets/svg/pdf.svg" class="download-img-btn" (click)="downloadReport('pdf')" />
          <img src="assets/svg/excel.svg" class="download-img-btn" (click)="downloadReport('excel')" />
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="table-container" *ngIf="selectedFilters.selectedEmpId">
    <table class="hover">
      <thead>
        <tr>
          <th class="mat-checkbox-style text-center">
            <mat-checkbox value="true" [(ngModel)]="isAllSelected" matTooltip="Select all tasks on this page" (change)="selectALLDwms($event, paginatedData)"></mat-checkbox>
          </th>
          <ng-container *ngFor="let item of teamTableHeaders; let i = index">
            <th class="fs-14 fs_12ForMobile font_bold cl-black sortable" (click)="onSort(item.key)">
              <div class="verticle-center justify-content-space-between icon-style">
                {{ item?.label }}
                <span class="red-cl" *ngIf="item?.required">&nbsp;*</span>
                <div class="sort-records-container d-flex flex-column ml-5">
                  <ion-icon name="caret-up-outline" [class.active]="tableState.sortColumn === item?.key && tableState.sortDirection === 'asc'"></ion-icon>
                  <ion-icon name="caret-down-outline" [class.active]="tableState.sortColumn === item?.key && tableState.sortDirection === 'desc'"></ion-icon>
                </div>
              </div>
            </th>
          </ng-container>
          <th class="text-center" *ngIf="userIsAdminTypes?.userIsAdmin">Action</th>
        </tr>
      </thead>

      <tbody *ngIf="paginatedData?.length != 0">
        <tr *ngFor="let item of paginatedData; let i = index" (click)="selectedTaskId = item.id">
          <!-- Check Box -->
          <td class="mat-checkbox-style text-center">
            <mat-checkbox [checked]="item?.checkboxCheck" [(ngModel)]="item.checkboxCheck" (change)="selectSingleDwm($event, item, i)" [disabled]="item?.dwmStatus === 'Completed'"></mat-checkbox>
          </td>

          <!-- Remaining Data -->
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.categoryName }}</span>
            <ng-select *ngIf="userIsAdminTypes?.userIsAdmin" class="w-100 mw-sm-175" [clearable]="false" placeholder="Select Category" [(ngModel)]="item.categoryName" [items]="dwmCategories" bindLabel="categoryName" bindValue="categoryName" appendTo="body" dropdownPosition="top" [class.field-required]="item?.isRequiredCategory" (change)="onProductChange(item)">
              <ng-option *ngFor="let c of dwmCategories" [value]="c">{{ c.categoryName }}</ng-option>
            </ng-select>
          </td>
          <td *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd">
            <span *ngIf="!userIsAdminTypes?.userIsAdmin || !(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')">{{ item?.productId }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && (item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')">
              <ng-select class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Product" [(ngModel)]="item.productId" [items]="productList" bindLabel="productNumber" bindValue="productId" appendTo="body" dropdownPosition="top" [disabled]="!(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')" (change)="onProductChange(item)" [class.field-required]="item?.isRequiredProductId"></ng-select>
            </span>
          </td>
          <td *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd">
            <span>{{ item?.plantLocation }}</span>
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.actionable }}</span>
            <textarea *ngIf="userIsAdminTypes?.userIsAdmin" rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.actionable)" class="min-w-sm-150" [class.field-required]="item?.isRequiredActionable" [(ngModel)]="item.actionable" placeholder="Type here.."></textarea>
          </td>
          <td *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd">
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.dwmDuration }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && (item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')">
              <input matInput class="dwm-input table-input" type="text" inputmode="numeric" placeholder="HH:MM" maxlength="5" [disabled]="!(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')" [(ngModel)]="item.dwmDuration" (keydown)="onDurationInput(item, $event)" (input)="onDurationInput(item, $event)" (blur)="onDurationBlur(item)" [class.field-required]="item?.isRequiredDwmDuration" />
              <mat-error *ngIf="maxDurationError">Maximum allowed duration is 24:00</mat-error>
            </span>
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.timeFrom | timeAmPm }}</span>
            <input *ngIf="!item.checkIfIsL4AndAboveEmployee && userIsAdminTypes?.userIsAdmin && item?.categoryName && !(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')" matInput type="time" [(ngModel)]="item.timeFrom" [class.field-required]="item?.isRequiredTimeFrom" />
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.timeTo | timeAmPm }}</span>
            <input *ngIf="!item.checkIfIsL4AndAboveEmployee && userIsAdminTypes?.userIsAdmin && item?.categoryName && !(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D')" matInput type="time" [(ngModel)]="item.timeTo" [class.field-required]="item?.isRequiredTimeTo" />
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.isRepetativeTask }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && !item?.isNew">{{ item?.isRepetativeTask }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && !(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D') && item?.isNew && item?.categoryName">
              <mat-slide-toggle [checked]="item.isRepetativeTask" [(ngModel)]="item.isRepetativeTask"></mat-slide-toggle>
            </span>
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.dwmFrequency }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && !item?.isNew">{{ item?.dwmFrequency }}</span>
            <span *ngIf="userIsAdminTypes?.userIsAdmin && !(item.categoryName == 'R&D-Project' || item.categoryName == 'R&D') && item?.isNew && item?.categoryName">
              <ng-select *ngIf="!item?.checkIfIsL4AndAboveEmployee" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency" [(ngModel)]="item.dwmFrequency" appendTo="body" dropdownPosition="top" [disabled]="!item.isRepetativeTask || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredFrequency">
                <ng-option *ngFor="let f of getMonthalyFrequency" [value]="f" [disabled]="f === 'HOURLY' && (!item?.timeFrom || !item?.timeTo)">{{ f }}</ng-option>
              </ng-select>
              <ng-select *ngIf="item?.checkIfIsL4AndAboveEmployee" class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Frequency" [(ngModel)]="item.dwmFrequency" [items]="getMonthalyFrequencyForL4AndAbove" appendTo="body" dropdownPosition="top" [disabled]="!item.isRepetativeTask || !item.isCutoffTaskEditable" [class.field-required]="item?.isRequiredFrequency">
                <ng-option *ngFor="let f of getMonthalyFrequencyForL4AndAbove" [value]="f">{{ f }}</ng-option>
              </ng-select>
            </span>
          </td>

          <td>
            <div class="dwm-status-icons" *ngIf="!item?.isNew">
              <button class="transparent-ghost-btn radius-100" (click)="changeStatus(item, 'Not_Started')">
                <mat-icon class="dwm-status-icon not-started" [matTooltip]="dwmGenericServiceService.getStatusLabel('Not_Started')" [ngClass]="{ 'active': item?.dwmStatus === 'Not_Started', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">cancel</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" (click)="changeStatus(item, 'In_Progress')">
                <mat-icon class="dwm-status-icon in-progress" [matTooltip]="dwmGenericServiceService.getStatusLabel('In_Progress')" [ngClass]="{ 'active': item?.dwmStatus === 'In_Progress', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">radio_button_checked</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" [disabled]="isExitedSelectedDate" (click)="changeStatus(item, 'Completed')">
                <mat-icon class="dwm-status-icon complete" [matTooltip]="dwmGenericServiceService.getStatusLabel('Completed')" [ngClass]="{ 'active': item?.dwmStatus === 'Completed', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">check_circle</mat-icon>
              </button>
              <button class="transparent-ghost-btn radius-100" (click)="changeStatus(item, 'Done_with_delay')" [disabled]="!isExitedSelectedDate">
                <mat-icon class="dwm-status-icon complete-delay" [matTooltip]="dwmGenericServiceService.getStatusLabel('Done_with_delay')" [ngClass]="{ 'active': item?.dwmStatus === 'Done_with_delay', 'is-skipped': dwmSkippDay.empComment === 'Accept skip day'}">check_circle</mat-icon>
              </button>
            </div>
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{ item?.empComments }}</span>
            <textarea *ngIf="userIsAdminTypes?.userIsAdmin && !item.isNew" rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.empComments)" (change)="changeStatus(item, '')" class="min-w-sm-150" [(ngModel)]="item.empComments" placeholder="Type here.."></textarea>
          </td>
          <td>
            <span *ngIf="!userIsAdminTypes?.userIsAdmin">{{item?.managerComments}}</span>
            <textarea *ngIf="userIsAdminTypes?.userIsAdmin && !item.isNew" rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.managerComments)" (change)="changeStatus(item, '')" class="min-w-sm-150" [(ngModel)]="item.managerComments" placeholder="Type here.."></textarea>
          </td>
          <td class="text-center">
            <span *ngIf="!userIsAdminTypes?.userIsAdmin"><button *ngIf="item?.dwmDoc" class="clear-filter-btn text-blue" (click)="onAttachmentDownload(item)">Download</button></span>

            <span *ngIf="userIsAdminTypes?.userIsAdmin">
              <input type="file" multiple #fileInput hidden (change)="uploadDWMAttachments($event, item)" />

              <span class="attachment-icon cp" matTooltip="Upload" *ngIf="!item.hasSavedAttachments" (click)="fileInput.click()">
                <img class="attachment" src="assets/icon/attachment.svg" />
              </span>

              <span *ngIf="item.hasSavedAttachments" class="see-attachment-wrapper">
                <span class="see-attachment cp" (click)="onAttachmentDownload(item)">See Attachment</span>
                <span class="remove-attachment cp" (click)="removeSavedAttachments(item)" title="Remove Attachment">✕</span>
              </span>
            </span>
          </td>
          <!-- -------------------------- Audit Trail ----------------------------- -->
          <td>
            <button mat-icon-button color="success" (click)="auditpopup(item.id)">
              <ion-icon name="document-text-outline"></ion-icon>
            </button>
          </td>
          <td *ngIf="userIsAdminTypes?.userIsAdmin">
            <div class="action-buttons">
              <button *ngIf="!item?.isNew" type="button" mat-icon-button color="primary" matTooltip="Update" [disabled]="selectedTaskList?.length > 0" (click)="saveUpdateDWM(item, '')">
                <ion-icon name="checkmark-outline"></ion-icon>
              </button>
              <button *ngIf="item?.isNew" type="button" mat-icon-button color="primary" matTooltip="Save New Task" [disabled]="selectedTaskList?.length > 0" (click)="onSaveNewDwm([item], paginatedData, i)">
                <ion-icon name="checkmark-outline"></ion-icon>
              </button>
              <button *ngIf="item?.isNew" type="button" mat-icon-button color="warn" matTooltip="Removes" [disabled]="selectedTaskList?.length > 0" (click)="removeTask(paginatedData, i)">
                <ion-icon name="trash-outline"></ion-icon>
              </button>
            </div>
          </td>
          <!-- End -->
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!selectedFilters.selectedEmpId" class="text-center p-20 fs-14">Please select an employee to view DWM records.</div>

  <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="paginatedData?.length != 0 && selectedFilters.selectedEmpId">
    <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries</ion-label>

    <div class="phi-flex-wrap-center phi-gap-12">
      <div class="phi-flex-wrap-center phi-gap-8">
        <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
        <mat-form-field class="w70px mat-height40 mat-input-style">
          <mat-select placeholder="Select" (selectionChange)="changePageSize($event.value)" [value]="pageSize">
            <mat-option [value]="25">25</mat-option>
            <mat-option [value]="50">50</mat-option>
            <mat-option [value]="75">75</mat-option>
            <mat-option [value]="100">100</mat-option>
          </mat-select>
        </mat-form-field>
        <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
      </div>

      <ul class="dt_pagination">
        <li class="active fs-16 fs_14ForMobile font_regular">
          {{ currentPage }}
        </li>
        <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalPages }}</span>
        <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage - 1)" [ngClass]="{ disableBtn: currentPage === 1 }">&lt;</li>
        <li class="fs-24 fs_18ForMobile cp" (click)="changePage(currentPage + 1)" [ngClass]="{ disableBtn: currentPage === totalPages }">&gt;</li>
      </ul>
    </div>
  </div>
</div>
